/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_ProcessingInputs */

const cs_property_ai_processing = /** @type {(inputs: Property_Ai_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI zpracovává tuto fotku…`)
};

const en_property_ai_processing = /** @type {(inputs: Property_Ai_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI is processing this photo…`)
};

/**
* | output |
* | --- |
* | "AI is processing this photo…" |
*
* @param {Property_Ai_ProcessingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_processing = /** @type {((inputs?: Property_Ai_ProcessingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_ProcessingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_processing(inputs)
	return cs_property_ai_processing(inputs)
});